/**
 * @param {Array<String>} terms
 * @param {String} str
 * @return {boolean}
 */
export const outOfOrderSearch = (terms, str) => {
  return terms.every((term) => {
    return str.includes(term)
  })
}
